import { useState, useEffect } from "react";
import { supabase } from "@/libs/supabase";
import type { Post } from "@/types/channel/post";

export const usePosts = (channelId?: string) => {
	const [posts, setPosts] = useState<Post[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		if (!channelId) {
			setLoading(false);
			return;
		}

		const fetchPosts = async () => {
			try {
				const { data, error } = await supabase
					.from("posts")
					.select(`
            *,
            user:users(*),
            comments:comments(
              *,
              user:users(*)
            ),
            reactions:reactions(*)
          `)
					.eq("channel_id", channelId)
					.order("created_at", { ascending: false });

				if (error) throw error;
				setPosts(data);
			} catch (e) {
				setError(
					e instanceof Error ? e : new Error("投稿の取得に失敗しました"),
				);
			} finally {
				setLoading(false);
			}
		};

		fetchPosts();

		// リアルタ��ム購読
		const subscription = supabase
			.channel(`channel:${channelId}:posts`)
			.on(
				"postgres_changes",
				{
					event: "*",
					schema: "public",
					table: "posts",
					filter: `channel_id=eq.${channelId}`,
				},
				(payload) => {
					fetchPosts();
				},
			)
			.subscribe();

		return () => {
			subscription.unsubscribe();
		};
	}, [channelId]);

	return { posts, loading, error };
};
